document.addEventListener("DOMContentLoaded", function () {
    const banner = document.querySelector(".collection-banner");
    const header = document.querySelector(".header.transparent--true");
    
    if (window.innerWidth <= 768) {
        // Verificar si .collection-banner contiene el elemento con la clase específica
        if (banner && header && banner.querySelector(".collection-banner--image-hide-mobile")) {
        // Aplicar estilos a .header.transparent--true
        header.classList.remove("transparent--true");
        banner.classList.remove("collection-banner--has-bg");
        }
    }
});document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("line-item:change:end", async () => {
    // Espera breve para que Shopify procese bien el cambio de línea
    await new Promise(resolve => setTimeout(resolve, 200));

    const cart = await fetch("/cart.js").then(res => res.json());

    const SERVICE_VARIANT_ID = 55553278345481;
    const personalizedItems = cart.items.filter(item => item.properties?.["_knifeGraving"]);
    const serviceItems = cart.items.filter(item => item.variant_id === SERVICE_VARIANT_ID);

    for (const personalized of personalizedItems) {
      const linkedService = serviceItems.find(svc => svc.properties?.["_relatedProduct"] === personalized.variant_id.toString());

      if (!linkedService) continue;

      const maxQuantity = parseInt(linkedService.properties["_maxQuantity"]) || linkedService.quantity;

      if (personalized.quantity < linkedService.quantity) {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: linkedService.key, quantity: personalized.quantity }),
        });
      } else if (personalized.quantity > linkedService.quantity) {
        if (personalized.quantity <= maxQuantity) {
          await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: linkedService.key, quantity: personalized.quantity }),
          });
        }
      }
    }

    for (const service of serviceItems) {
      const hasProduct = personalizedItems.some(p => p.variant_id.toString() === service.properties?.["_relatedProduct"]);
      if (!hasProduct) {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: service.key, quantity: 0 }),
        });
      }
    }

    document.dispatchEvent(new CustomEvent("cart:refresh"));
  });
});


// document.addEventListener("DOMContentLoaded", function () {
//   const interval = setInterval(() => {
//     const el = document.getElementById("INDShadowRootHost");
//     if (el) {
//       el.style.setProperty("display", "none", "important");
//       clearInterval(interval);
//     }
//   }, 100); // intenta cada 100ms hasta que aparezca
// });


document.addEventListener("DOMContentLoaded", function() {
  var lazyImgs = document.querySelectorAll("img.lazyload");

  lazyImgs.forEach(function(img) {
    if (img.classList.contains("lazyload")) {
      lazySizes.loader.unveil(img);
    }
  });
});


// ==============================
// 1. CARGAR API DE YOUTUBE
// ==============================
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
document.head.appendChild(tag);

let players = {}; // almacenar instancias de players

// ==============================
// 2. INICIALIZAR YOUTUBE PLAYERS
// ==============================
function onYouTubeIframeAPIReady() {
  document.querySelectorAll('iframe.js-youtube').forEach((iframe, index) => {
    const id = iframe.id || "yt-player-" + index;
    iframe.id = id;

    players[id] = new YT.Player(id, {
      events: {
        'onStateChange': onPlayerStateChange
      }
    });
  });
}

// ==============================
// 3. MANEJAR EVENTOS YOUTUBE
// ==============================
function onPlayerStateChange(event) {
  const player = event.target;
  const data = event.data;
  const videoData = player.getVideoData();
  const videoUrl = player.getIframe().src;

  if (data === YT.PlayerState.PLAYING) {
    pushToDataLayer(player, videoData, videoUrl, "YouTube");
    trackYTProgress(player, videoData, videoUrl);
  }

  if (data === YT.PlayerState.PAUSED) {
    pushToDataLayer(player, videoData, videoUrl, "YouTube");
  }

  if (data === YT.PlayerState.ENDED) {
    pushToDataLayer(player, videoData, videoUrl, "YouTube", 100);
  }
}

// ==============================
// 4. FUNCIÓN GENERAL PARA DATA LAYER
// ==============================
function pushToDataLayer(playerOrVideo, videoData, videoUrl, provider, percent=null) {
  let duration, current, title;

  if (provider === "YouTube") {
    duration = playerOrVideo.getDuration();
    current = playerOrVideo.getCurrentTime();
    title = videoData.title || "Sin título";
  } else {
    duration = playerOrVideo.duration || 0;
    current = playerOrVideo.currentTime || 0;
    title = videoData.title || "Sin título";
  }

  const percentage = percent ?? Math.round((current / duration) * 100);

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event': 'video_progress',
    'event_category': 'videos',
    'video_title': title,
    'video_url': videoUrl,
    'video_percent': percentage,
    'video_duration': duration,
    'video_provider': provider
  });

}

// ==============================
// 5. TRACKING DE PROGRESO YOUTUBE
// ==============================
function trackYTProgress(player, videoData, videoUrl) {
  let checkpoints = [25, 50, 75];
  let done = {};

  const interval = setInterval(() => {
    if (player.getPlayerState() !== YT.PlayerState.PLAYING) return;

    const current = player.getCurrentTime();
    const duration = player.getDuration();
    const percent = Math.round((current / duration) * 100);

    checkpoints.forEach(p => {
      if (percent >= p && !done[p]) {
        pushToDataLayer(player, videoData, videoUrl, "YouTube", p);
        done[p] = true;
      }
    });

    if (percent >= 100) clearInterval(interval);
  }, 1000);
}

// ==============================
// 6. TRACKING HTML5 <video>
// ==============================
document.addEventListener("DOMContentLoaded", () => {
  const videos = document.querySelectorAll("video");

  videos.forEach(video => {
    const title = video.getAttribute("title") || "Sin título";
    const url = video.currentSrc || video.src;

    video.addEventListener("play", () => {
      if (video.hasAttribute("autoplay") || video.hasAttribute("loop")) return;
      pushToDataLayer(video, {title}, url, "HTML5");
      trackHTML5Progress(video, {title}, url);
    });

    video.addEventListener("pause", () => {
      if (video.hasAttribute("autoplay") || video.hasAttribute("loop")) return;
      pushToDataLayer(video, {title}, url, "HTML5");
    });

    video.addEventListener("ended", () => {
      if (video.hasAttribute("autoplay") || video.hasAttribute("loop")) return;
      pushToDataLayer(video, {title}, url, "HTML5", 100);
    });
  });
});

function trackHTML5Progress(video, videoData, videoUrl) {
  let checkpoints = [25, 50, 75];
  let done = {};

  const interval = setInterval(() => {
    if (video.paused || video.ended) return;

    const current = video.currentTime;
    const duration = video.duration;
    const percent = Math.round((current / duration) * 100);

    checkpoints.forEach(p => {
      if (percent >= p && !done[p]) {
        pushToDataLayer(video, videoData, videoUrl, "HTML5", p);
        done[p] = true;
      }
    });

    if (video.ended) clearInterval(interval);
  }, 1000);
}


document.addEventListener("DOMContentLoaded", () => {
  const form = document.querySelector("#contact_form");

  if (!form) return;

  form.addEventListener("submit", (e) => {
    e.preventDefault(); // evitar envío inmediato para validar

    let envioCorrecto = form.checkValidity(); // validación nativa HTML5
    let detalleError = envioCorrecto ? "envío ok" : "";

    // Buscar mensaje de error si existe
    if (!envioCorrecto) {
      const invalidInput = form.querySelector(":invalid");
      if (invalidInput) {
        detalleError = invalidInput.title || invalidInput.validationMessage || "Error en el formulario";
      }
    }

    // Enviar evento a dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'alta_newsletter',
      'event_category': 'formularios',
      'method': 'formulario footer',
      'form_name': 'newsletter',
      'form_submit_text': 'suscribeme',
      'envio_correcto': envioCorrecto,
      'detalle_error': detalleError
    });

    // Si el formulario es válido, se puede enviar realmente
    if (envioCorrecto) {
      form.submit(); // enviar el formulario
    }
  });
});


function equalizeProductCardHeights() {
  // Ahora igualamos las alturas de las tarjetas
  document.querySelectorAll('.flickity-slider').forEach(slider => {
    
    const freeShippingTexts = slider.querySelectorAll('.lg-free-shipping--text');

    // Si hay textos y todos tienen visibility:hidden → ocultarlos temporalmente
    if (freeShippingTexts.length > 0) {
      const allHidden = Array.from(freeShippingTexts).every(
        p => window.getComputedStyle(p).visibility === 'hidden'
      );

      if (allHidden) {
        freeShippingTexts.forEach(p => {
          p.style.display = 'none';
        });
      }
    }

    const cards = slider.querySelectorAll('product-card');
    if (!cards.length) return;
    cards.forEach(card => card.style.minHeight = 'auto');
    const max = Math.max(...Array.from(cards).map(c => c.offsetHeight));
    cards.forEach(c => c.style.minHeight = `${max}px`);
  });
}

window.addEventListener('load', equalizeProductCardHeights);
window.addEventListener('resize', equalizeProductCardHeights);